import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {ScrollService} from './scroll-service';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  constructor(private scrollService: ScrollService,) {}

  private loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setLoadingValue(value: boolean) {
    this.loading.next(value);
    if (value) {
      // this.scrollService.lockScroll();
    } else {
      // this.scrollService.lockScroll();
    }
  }

  getLoading() {
    return this.loading.value;
  }

}
